// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Xs9c","header":"ReportDetails_header__1c3B2","title":"ReportDetails_title__3AKY9","left":"ReportDetails_left__3W9Lj"};